import React, { useContext } from 'react';

export interface ExternalLessonContextModel {
    /** Value indicating whether lesson coming through integration. */
    isExternalLesson?: boolean;
  }
  
  const ExternalLessonContext = React.createContext<ExternalLessonContextModel>({
    isExternalLesson: false
  });
  
  export const useExternalLessonContext = () => useContext(ExternalLessonContext);
  export const ExternalLessonContextProvider = ExternalLessonContext.Provider;
  export const ExternalLessonContextConsumer = ExternalLessonContext.Consumer;